<template>
    <label :for="selectId">
        <div v-if="label" class="text-gray600 my-10">{{ label }}</div>
        <div class="custom-select-wrapper">
            <select
                :id="selectId"
                class="custom-select w-full"
                :value="modelValue"
                @change="$emit('update:modelValue', $event.target.value)"
            >
                <option v-if="!hideDefault" value>Show All</option>
                <option
                    v-for="option in computedOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
        </div>
    </label>
</template>

<script>
import formatLabel from '../../helpers/formatLabel';

let nextSelectId = 0;

// Select used by residential and commercial search forms.
export default {
    props: {
        label: { type: String, default: '' },
        options: { type: [Array, Object], default: () => [] },
        modelValue: { type: [String, Number], default: '' },
        emptyOverride: { type: String, default: '' },
        hideDefault: { type: Boolean, default: false },
    },
    emits: ['update:modelValue'],
    data() {
        nextSelectId += 1;
        return { selectId: `v-select-${nextSelectId}` };
    },
    computed: {
        computedOptions() {
            const entries = Array.isArray(this.options)
                ? this.options.map(option => Array.isArray(option) ? option : [option, option])
                : Object.entries(this.options || {});

            return entries
                .filter(([value]) => value !== '')
                .map(([value, option]) => ({
                    value,
                    label: formatLabel(option, this.emptyOverride),
                }));
        },
    },
};
</script>
